<div class="page-header">
    <div class="col-12">
        <h1>FTE Projections <small>View PR and Job Cost FTE Projections</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Overhead FTE Projections</a>
        </li>
        <li [ngbNavItem]="3">
            <a ngbNavLink>Overhead FTE Actuals</a>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Job Type FTE Projections</a>
        </li>
        <li [ngbNavItem]="6">
            <a ngbNavLink>Job Type FTE Actuals</a>
        </li>
        <li [ngbNavItem]="5">
            <a ngbNavLink>JC Class FTE Projections</a>
        </li>
        <li [ngbNavItem]="7">
            <a ngbNavLink>JC Class FTE Actuals</a>
        </li>
        <li [ngbNavItem]="8">
            <a ngbNavLink>PR Cost By Position Code</a>
        </li>
        <!--<li [ngbNavItem]="3">
        <a ngbNavLink>Job Count By Revenue</a>
    </li>-->
        <li [ngbNavItem]="4">
            <a ngbNavLink>PR FTE Historical Chart</a>
        </li>
    </ul>
    <div style="margin-top: 10px">
        <!-- This is the header and the toolbar -->
        <div class="row action-toolbar">
            <!--<h4>{{gridHeader}}</h4>-->
            <div class="col-12" style="margin-top: 15px">
                <form class="form-inline">
                    <action-toolbar-count [grid]="fteGrid"></action-toolbar-count>
                    <grid-export [grid]="gridfte" [name]="'FTE Projections'"></grid-export>
                    <div class="input-header-group">
                        <span class="input-header">Start Date</span>
                        <wj-input-date
                            [(ngModel)]="startDate"
                            class="header-input"
                            name="startDate"
                            [min]="minDate"
                            [max]="maxDate"
                            (ngModelChange)="refreshFteData()"
                            [selectionMode]="'Month'"
                            [format]="'MMM yyyy'"
                        ></wj-input-date>
                    </div>
                    <div class="input-header-group">
                        <span class="input-header">End Date</span>
                        <wj-input-date
                            [(ngModel)]="endDate"
                            class="header-input"
                            name="endDate"
                            [min]="minDate"
                            [max]="maxDate"
                            (ngModelChange)="refreshFteData()"
                            [selectionMode]="'Month'"
                            [format]="'MMM yyyy'"
                        ></wj-input-date>
                    </div>
                    <div class="input-header-group" [hidden]="active === 100">
                        <span class="input-header">Monthly Hours 1</span>
                        <input
                            type="number"
                            class="form-control header-input"
                            [(ngModel)]="monthlyHours1"
                            name="monthlyHours1"
                            (ngModelChange)="refreshFteData()"
                        />
                    </div>
                    <div class="input-header-group" [hidden]="active === 100">
                        <span class="input-header">Monthly Hours 2</span>
                        <input
                            type="number"
                            class="form-control header-input"
                            [(ngModel)]="monthlyHours2"
                            name="monthlyHours2"
                            (ngModelChange)="refreshFteData()"
                        />
                    </div>
                    <div class="input-header-group" [hidden]="active === 3 || active === 6">
                        <span class="input-header">Calculation Based On</span>
                        <wj-combo-box
                            style="width: 140px"
                            [(ngModel)]="isRevenue"
                            name="isRevenue"
                            (ngModelChange)="refreshFteData()"
                            [itemsSource]="boolMap"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                    <button class="btn btn-sm btn-secondary" style="margin-left: auto" (click)="updateData()">Update Data</button>
                </form>
            </div>
        </div>

        <div [hidden]="active > 3 && active < 5">
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridfte"
                        #gridfte
                        appAutoSize
                        [padding]="73"
                        (initialized)="fteGrid.initialize(gridfte)"
                        [itemsSource]="fteGrid.view"
                        [keyActionTab]="'MoveAcross'"
                        [itemFormatter]="fteGridItemFormatter"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="colHeader" [binding]="'deptDescription'" [width]="250"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Code'"
                            [binding]="'department'"
                            [width]="75"
                            [visible]="active === 1 || active === 3"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Craft/Class'"
                            [binding]="'department'"
                            [width]="180"
                            [visible]="active === 5"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Monthly Hours'"
                            [binding]="'monthlyHours'"
                            [width]="100"
                            [visible]="active === 1 || active === 2 || active === 3 || active === 6"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Last Month Actuals'"
                            [binding]="'lastMonth'"
                            [width]="100"
                            [cssClass]="'italics'"
                            [visible]="active === 1 || active === 2 || active === 5"
                        ></wj-flex-grid-column>
                        <wj-flex-grid-column
                            *ngFor="let month of fteMonthCols"
                            [binding]="'fteByMonth.' + month"
                            [format]="'N2'"
                            [align]="'right'"
                            [header]="month"
                            [aggregate]="'Sum'"
                            [width]="110"
                            [isReadOnly]="false"
                        >
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridfte"></grid-selection-calculation>
                </div>
            </div>

            <div class="row action-toolbar" style="margin-top: 20px" [hidden]="active !== 1">
                <h4>PR Department Data</h4>
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="prDeptGrid"></action-toolbar-count>
                        <grid-export [grid]="gridPrDept" [name]="'PR Department Data'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row" [hidden]="active !== 1">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridPrDept"
                        #gridPrDept
                        style="height: 350px"
                        (initialized)="prDeptGrid.initialize(gridPrDept)"
                        [itemsSource]="prDeptGrid.view"
                        [keyActionTab]="'MoveAcross'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <!--<wj-flex-grid-column [header]="'PRCo'" [binding]="'prCo'" [width]="'*'"></wj-flex-grid-column>-->
                        <!--<wj-flex-grid-column [header]="'CoName'" [binding]="'coName'" [width]="'*'"></wj-flex-grid-column>-->
                        <wj-flex-grid-column [header]="'Month'" [binding]="'month'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Dept'" [binding]="'dept'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'PR_JC_SM_Department'" [binding]="'deptType'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Hours'" [binding]="'hours'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'EarnAmt'" [binding]="'earnAmt'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridPrDept"></grid-selection-calculation>
                </div>
            </div>

            <div class="row action-toolbar" style="margin-top: 20px" [hidden]="active === 1 || active === 4">
                <h4>JC Cost Details Data</h4>
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="jccdGrid"></action-toolbar-count>
                        <grid-export [grid]="gridJccd" [name]="'PR Department Data'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row" [hidden]="active === 1 || active === 4">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridJccd"
                        #gridJccd
                        style="height: 350px"
                        (initialized)="jccdGrid.initialize(gridJccd)"
                        [itemsSource]="jccdGrid.view"
                        [keyActionTab]="'MoveAcross'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Month'" [binding]="'month'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Dept'" [binding]="'dept'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'PR_JC_SM_Department'" [binding]="'deptType'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Hours'" [binding]="'hours'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'EarnAmt'" [binding]="'earnAmt'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Craft'" [binding]="'craft'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Class'" [binding]="'class'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridJccd"></grid-selection-calculation>
                </div>
            </div>

            <div class="row action-toolbar" style="margin-top: 20px">
                <h4>Earned Revenue</h4>
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="earnedRevenueGrid"></action-toolbar-count>
                        <grid-export [grid]="gridEarnedRevenue" [name]="'Earned Revenue'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridEarnedRevenue"
                        #gridEarnedRevenue
                        style="height: 350px"
                        (initialized)="earnedRevenueGrid.initialize(gridEarnedRevenue)"
                        [itemsSource]="earnedRevenueGrid.view"
                        [keyActionTab]="'MoveAcross'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'WIP Month'" [binding]="'wipmonth'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobNum'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Earned Curr Mth'" [binding]="'earnedCurrMth'" [width]="'*'"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridEarnedRevenue"></grid-selection-calculation>
                </div>
            </div>

            <div class="row action-toolbar" style="margin-top: 20px">
                <h4>Projected Revenue</h4>
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="projectedRevenueGrid"></action-toolbar-count>
                        <grid-export [grid]="gridProjectedRevenue" [name]="'Projected Revenue'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridProjectedRevenue"
                        #gridProjectedRevenue
                        style="height: 350px"
                        (initialized)="projectedRevenueGrid.initialize(gridProjectedRevenue)"
                        [itemsSource]="projectedRevenueGrid.view"
                        [keyActionTab]="'MoveAcross'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <wj-flex-grid-column [header]="'Work Off Month'" [binding]="'workoffMonth'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job'" [binding]="'jobNum'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Job Type'" [binding]="'jobType'" [width]="'*'"></wj-flex-grid-column>
                        <wj-flex-grid-column
                            [header]="'Projected Revenue'"
                            [binding]="'projectedRevenue'"
                            [width]="'*'"
                        ></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridProjectedRevenue"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="active === 4">
        <div class="row">
            <div class="col-12">
                <wj-flex-chart
                    appAutoSize
                    [itemsSource]="chartData?.points"
                    [bindingX]="'label'"
                    [chartType]="'Column'"
                    [stacking]="'Stacked'"
                    [header]="chartData?.title"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Right'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'FTE Equivalent'" [format]="'N2'" [min]="0"></wj-flex-chart-axis>
                    <wj-flex-chart-series *ngFor="let serie of chartData?.series" [binding]="serie.binding" [name]="serie.name">
                    </wj-flex-chart-series>
                </wj-flex-chart>
            </div>
        </div>
    </div>
</div>
